import { ActionReducerMap } from "@ngrx/store";
import { ApplicationFeatureState } from "./application/application.state";
import * as ApplicationReducers from "./application/reducers/application.reducers";
import * as NotificationReducers from "./notification/notification.reducers";
import { NotificationFeatureState } from "./notification/notification.state";
import { QuoteFeatureState as Pillar3aQuoteFeatureState } from "./quote/pillar-3a/quote.state";
import * as Pillar3aQuoteReducers from "./quote/pillar-3a/reducers/quote.reducers";
import { QuoteFeatureState as TermLifeInsuranceQuoteFeatureState } from "./quote/term-life-insurance/quote.state";
import * as TermLifeInsuranceQuoteReducers from "./quote/term-life-insurance/reducers/quote.reducers";

export interface AppState {
  // Quote
  termLifeInsuranceQuote: TermLifeInsuranceQuoteFeatureState;
  pillar3aQuote: Pillar3aQuoteFeatureState;
  // Others
  application: ApplicationFeatureState;
  notification: NotificationFeatureState;
}

export const appReducer: ActionReducerMap<AppState> = {
  termLifeInsuranceQuote: TermLifeInsuranceQuoteReducers.featureReducer,
  pillar3aQuote: Pillar3aQuoteReducers.featureReducer,
  application: ApplicationReducers.featureReducer,
  notification: NotificationReducers.featureReducer,
};
